import { isServerSide } from './isServerSide';
const updateDataLayer = (eventPayload) => {
    if (!isServerSide()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventPayload);
    }
};
export default updateDataLayer;
